/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum UserRole {
  Admin = 1,
  TechnicalLeader = 2,
  CodeQualityResponsible = 3,
  Member = 4
}
